import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="relative border-t border-gray-200 dark:border-gray-800 bg-white/80 dark:bg-slate-900/80">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 max-w-7xl">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            © {new Date().getFullYear()} travelbaba786. Independent travel information directory.
          </p>
          <nav className="flex flex-wrap gap-4 text-sm font-semibold">
            <Link to="/about" className="text-gray-600 dark:text-gray-300 hover:text-blue-600">
              About
            </Link>
            <Link to="/contact" className="text-gray-600 dark:text-gray-300 hover:text-blue-600">
              Contact
            </Link>
            <Link to="/privacy" className="text-gray-600 dark:text-gray-300 hover:text-blue-600">
              Privacy
            </Link>
            <Link to="/terms" className="text-gray-600 dark:text-gray-300 hover:text-blue-600">
              Terms
            </Link>
          </nav>
        </div>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-3">
          <a href="mailto:liaqatapril@gmail.com" className="hover:text-blue-600">
            liaqatapril@gmail.com
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
